import {Component} from '@angular/core';
import {PatientsApplicationsService} from '../../../../shared/services/patients-applications.service';
import {Patient} from '../../../../shared/models/pateint';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import {ApplicationsPatientFilesDialogComponent} from '../../components/applications-patient-file-dialog/applications-patient-file-dialog.component';
import {Subject, takeUntil} from "rxjs";
import { NameValidator } from '../../../../shared/models/name-validator';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-applications-patient-profile',
  templateUrl: './applications-patient-profile.component.html',
  styleUrls: ['./applications-patient-profile.component.css'],
})
export class ApplicationsPatientProfileComponent {
  patientData: Patient = new Patient({} as Patient);
  initDate = new Date();
  nameChanged: boolean = false;
  nameIsEdited: boolean = false;
  destroy$: Subject<any> = new Subject<any>();

  constructor(
    private patientDataService: PatientsApplicationsService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private messageService: MessageService
  ) {

    const patientId = this.route.snapshot.paramMap.get('id');
    this.getPatientByID(patientId);
    this.initDate.setDate(this.initDate.getDate() + 2);
  }
  items: any;
  home: any;
  getPatientByID(id: any) {
    this.patientDataService
      .getPatientById(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((patient) => {
        this.patientData = new Patient(patient);


        if (this.patientData.mrn && this.patientData.mrn.length > 0) {
          this.applicationForm.get('mrn')?.setValue(this.patientData.mrn);
        }
        if (!this.patientData.patientApplication.id) {
          this.applicationForm.disable();
        } 
        this.items = [
          // { label: 'Applications List', routerLink: '/applications' },
          { label: this.patientData.name }
        ];
        this.home = { icon: 'pi pi-home', routerLink: '/applications' };
      });
  }

  openDialog(index: number): void {
    const dialogRef = this.dialog.open(ApplicationsPatientFilesDialogComponent, {
      data: {file: this.patientData.files[index], patient: this.patientData},
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
    });
  }

  options = ['PENDING','INVALID', 'INCOMPLETE', 'ACCEPTED', 'REJECTED'];
  applicationForm = this.fb.group({
    caseStatus: [''],
    mrn: [''],
    appointmentDate: [ new Date()],
  });

  tempName: string = "";
  editName() {
    this.tempName = this.patientData.name;
    this.nameIsEdited = true;
  }
 
  saveName() {
    if (NameValidator.validateInput(this.tempName)) {
      //won't save if name is not changed
      if (!this.nameChanged) {
        this.nameIsEdited = false;
        return;
      }
      this.patientData.name = this.tempName;
      this.patientDataService.setName(this.patientData).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.getPatientByID(this.patientData.id);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Name Updated' });
        this.nameIsEdited = false;
      });
    } else {
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Invalid Name'});
    }
  }

  cancel() {
    this.nameIsEdited = false;
    this.nameChanged = false;
  }

  submitApplication() {
    if (this.applicationForm.invalid || !this.patientData.patientApplication.id) {
      return;
      }
    const applicationStatus = this.applicationForm.get('caseStatus')?.value;
    const mrn = this.applicationForm.get('mrn')?.value || this.patientData.mrn
    let appointmentDate: Date;
    if (applicationStatus === 'ACCEPTED') {
      appointmentDate = this.applicationForm.get('appointmentDate')?.value || new Date();
    }
    else {
      appointmentDate = this.initDate;
    }

    let localISOTime = new Date(appointmentDate.getTime() - (appointmentDate.getTimezoneOffset() * 60000)).toISOString().slice(0, -1);

    this.patientDataService.setStatus(this.patientData.patientApplication.id, mrn || "", applicationStatus || "", localISOTime)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (data) => {
          this.getPatientByID(this.patientData.id);
          this.applicationForm.reset();
        }
      });
  }

  validateNumber(event: any) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 37, 39, 46];

    // Allow copy and paste
    if (event.ctrlKey && (keyCode === 86 || keyCode === 67)) {

      //timeout to allow the value to be pasted
      setTimeout(() => {
        this.validateString();
      }, 100);
      return;
    }

    if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || excludedKeys.includes(keyCode))) {
      event.preventDefault();
    }
  }
  validateString() {
    this.applicationForm.get('mrn')?.setValue(this.applicationForm.get('mrn')?.value?.trim() || "");
    let str = this.applicationForm.get('mrn')?.value;

    if (str) {
      const isNumbers = /^\d+$/.test(str);
      const hasArabicLetters = /[\u0600-\u06FF]/.test(str);
      const hasEnglishLetters = /[a-zA-Z]/.test(str);
      const hasOtherCharacters = /[^a-zA-Z0-9\u0600-\u06FF\s]/.test(str);
      if (hasArabicLetters || hasEnglishLetters || hasOtherCharacters) {
        this.applicationForm.get('mrn')?.setValue("");
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid MRN' });
      }
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next('');
    this.destroy$.complete();
  }

  visible: boolean = false;
  showDialog() {
    this.visible = true;
  }
}
